import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const Sunflowers = () => (
  <StaticImage
    src='../../../images/framedDisplay/runOne/sunflowers-van-gogh-web-sample-run-1.png'
    alt='Dandy Lines Boogie-Woogie: Vincent Van-Gogh, Sunflowers'
  />
);

export default Sunflowers;
